import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import OrderListRow from "@/components/admin/OrderListRow.vue";
import { Formatter } from "@/util/Formatter";
import { onMounted, watch } from "vue";
import { useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderList',
    props: {
        orders: { type: Array, required: true },
        search: { type: String, required: false, default: '' },
    },
    setup(__props) {
        const props = __props;
        let orderLookup = new Map();
        const router = useRouter();
        onMounted(() => {
            props.orders.forEach(order => orderLookup.set(order.id, order));
        });
        watch(() => props.orders, (newOrders) => {
            orderLookup = new Map();
            newOrders.forEach(order => orderLookup.set(order.id, order));
        }, { deep: true });
        function sortByCustomer(a, b) {
            const aName = a.firstname + ' ' + a.lastname;
            const bName = b.firstname + ' ' + b.lastname;
            if (aName < bName)
                return -1;
            if (aName > bName)
                return 1;
            return 0;
        }
        function filterCustomer(value, query) {
            if (!value || query == null)
                return false;
            let name = value.firstname + ' ' + value.lastname;
            return name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                value.email.toLowerCase().indexOf(query.toLowerCase()) > -1;
        }
        function filterOrderDatetime(value, query) {
            return Formatter.date(value).indexOf(query) > -1;
        }
        function filterBookingNumber(value, query, item) {
            const completeOrder = orderLookup.get(item.raw.id);
            if (!completeOrder)
                return true;
            return Formatter.bookingNumber(completeOrder).toLowerCase().indexOf(query.toLowerCase()) > -1;
        }
        function rowClick(clickedOrder) {
            router.push({ name: 'admin-orders-edit', params: { id: clickedOrder.id.toString() } });
        }
        return (_ctx, _cache) => {
            const _component_v_data_table = _resolveComponent("v-data-table");
            return (_openBlock(), _createBlock(_component_v_data_table, {
                "data-cy": "orderList",
                "items-per-page": 100,
                items: __props.orders,
                search: __props.search,
                "custom-key-filter": { 'customer': filterCustomer, 'orderDatetime': filterOrderDatetime, 'bookingNumber': filterBookingNumber },
                "custom-key-sort": { 'customer': sortByCustomer },
                "filter-mode": "some",
                "sort-by": [{ key: 'orderDatetime', order: 'desc' }],
                headers: [
                    {
                        title: 'Buchungsnummer',
                        align: 'start',
                        sortable: true,
                        key: 'bookingNumber',
                    },
                    {
                        title: 'Kunde',
                        sortable: true,
                        key: 'customer',
                    },
                    {
                        title: 'Buchungsdatum',
                        align: 'start',
                        sortable: true,
                        key: 'orderDatetime',
                    },
                    {
                        title: 'Status',
                        align: 'start',
                        sortable: true,
                        key: 'orderStatus'
                    },
                    {
                        title: 'Anmerkungen',
                        align: 'start',
                        sortable: true,
                        key: 'customerRemarks',
                    }
                ]
            }, {
                item: _withCtx(({ item }) => [
                    _createVNode(OrderListRow, {
                        class: "cursor-pointer",
                        order: item,
                        onClick: ($event) => (rowClick(item))
                    }, null, 8, ["order", "onClick"])
                ]),
                _: 1
            }, 8, ["items", "search", "custom-key-filter", "custom-key-sort"]));
        };
    }
});
